import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Typography from '../Typography';

export const Container = styled.div`
  flex: 1 1 auto;
  position: relative;
  width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 24px 32px;
  background: ${getPrefixedVar(['gistView', 'bg'])};
  min-height: 106px;

  @media (width <= 1200px) {
    padding: 16px 20px;
    min-height: auto;
  }
`;

export const TitleBlock = styled.div``;

export const ViewTitle = styled(Typography)`
  color: ${getPrefixedVar(['gistView', 'title'])};
`;

export const Body = styled.div`
  width: 100%;
  padding: 0 18px 24px 32px;
  display: flex;
  flex-direction: column;
  scrollbar-gutter: stable;
  flex: 1 1 auto;
  scroll-behavior: smooth;
  overflow: auto;

  @media (width <= 1200px) {
    padding: 0 11px 16px 20px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;

  @media (width <= 1200px) {
    column-gap: 8px;
  }
`;
